import styled from 'styled-components'

export const SpinnerStyle = styled.div`
    margin-top: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
`
